const translation = {
	confirm: 'Are you sure?',
	common: { back: 'Back' },
	save: 'Save',
	returnToGame: 'Are you sure you want to get back into the game?',
	yes: 'Yes',
	no: 'No',
	login: {
		auth: 'Authorization',
		noAcc: 'No account',
		reg: 'Register',
		mail: 'Login with email',
		registration: 'Registration',
		agreement: 'By clicking the "Sign Up" button, you confirm your',
		agreementLink: 'consent to the processing of personal data.',
		submit: 'Register',
		continue: 'Continue',
		emailLabel: 'Email',
		passwordLabel: 'Password',
		repeatPasswordLabel: 'Repeat password',
		loginButton: 'Log in',
		logout: 'Log out',
		invalidEmail: 'Invalid email format',
		invalidFormatPassword: 'Incorrect password format',
		forgotPassword: 'Forgot your password',
		passwordRecovery: 'Password recovery',
		passwordRecoveryTitle: 'We will send a letter to the specified email',
		sendLetter: 'Send letter',
		userExists: 'User with this email exists',
		userNotExists: 'User with this email does not exist',
		passwordResetToMail: 'Instructions for resetting your password have been sent by email',
		passwordValidation: 'Must contain from 8 to 20 Latin letters or numbers',
		invalidPassword: 'Incorrect password',
		sessionNotFound: 'Session not found',
		mismatchPassword: 'Password mismatch! Try again',
		rememberPassword: 'Remembered your password',
		restore: 'Restore',
		accExist: 'Have an account',
		confirmationCode: 'Enter the confirmation code sent by email',
		code: 'Confirmation code',
		send: 'Send',
		confirmation: 'Confirm',
		resend: 'Resend',
		codeIsValid: 'Code is valid',
		codeNotValid: 'Code is not valid',
		newPassword: 'Enter a new password',
		passwordUsedBefore: 'Password has already been used before',
		passwordUpdatedSuccessfully: 'Password updated successfully',
		enterEmail: 'Enter your email address',
		enterPassword: 'Enter password',
		enterPasswordAgain: 'Enter your password again',
		enterAgreement: 'Confirm your consent to the processing of personal data',
		notRobot: 'Prove that you are not a robot',
		deletionPersonalData: 'To delete personal data, send us a message to our email address.',
	},
	profile: {
		edit: 'Edit profile',
		remove: 'УDelete account',
		projectName: 'Project name',
		editing: 'Editing your profile',
		name: 'Your name',
		lastName: 'Your last name',
		inputPattern: 'From two to ten letters',
		purchases: 'No purchases',
		settings: 'Settings',
		transactions: 'Transactions',
	},
	payment: {
		toPay: 'to pay',
		method: 'Payment method',
		pay: 'Pay',
		purchases: 'Purchases',
		paymentMethod: 'Payment method',
		debitCard: 'Debit card',
		copy: 'Payment ID copied!',
		cancellation: 'Are you sure you want to cancel the payment?',
		email: 'Email to receive a receipt',
		status: {
			none: 'None',
			pending: 'Pending',
			paid: 'Paid',
			fail: 'Fail',
		},
		state: {
			progress: 'Payment is being processed',
			wait: 'Please wait',
			paid: 'Paid',
			successful: 'Payment was successful',
			notPaid: 'Not paid',
			error: 'Error',
			cancelled: 'Payment cancelled',
			cancel: 'Cancel',
		},
	},
	prices: {
		selectProject: 'Select a project',
		noPrices: 'No prices',
	},
	footer: {
		llc: 'PLAYFLOCK GAMING DEVELOPMENT',
		contacts: 'Contacts',
		offer: 'Offer',
		privacy: 'Privacy Policy',
		personalData: 'Personal Data Processing Policy PLAYFLOCK GAMING DEVELOPMENT',
		terms: 'Terms',
	},
	games: {
		header: {
			buttonGuest: 'Guest',
			buttonLogin: 'Login',
			buttonLogout: 'Logout',
		},
		buttonPlay: 'Play',
		buttonInDevelop: 'In development',
	},
	support: {
		noPurchases: 'You have no purchases yet',
		contactSupport: 'Contact support',
		paymentId: 'Payment ID',
		userId: 'User ID',
		requestReason: 'Reason for request',
		feedbackEmail: 'Email for feedback',
		dropNotCredited: 'Drop not credited',
		other: 'Other',
		success: 'Request accepted',
		successText: 'We have received your request and will contact you via email shortly',
	},
	receipt: {
		generation: 'Generating receipt',
		wait: 'This may take some time, please wait.'
	},
}

export default {
	translation,
}
